// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-next',
  revision: 'c9c720d4c',
  branch: 'next',
  date: 'Tue, 30 Jun 2026 10:04:41 GMT'
};